import React, { useEffect, useRef, useState } from 'react';

import { WishlistProvider } from '../context/WishlistContext';
import { translations } from '../i18n.js';

export const AppContext = React.createContext({
  breakpoint: 'desktop',
  t: (key) => key,
});

export function usePrevious(value) {
  const ref = useRef();

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
}

export default function Navigation({ children }) {
  const [breakpoint, setBreakpoint] = useState(window.innerWidth >= 1200 ? 'desktop' : 'mobile');
  const [languageMap] = useState(translations.en);

  useEffect(() => {
    const handleResize = () => {
      setBreakpoint(window.innerWidth >= 1200 ? 'desktop' : 'mobile');
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  function t(key, names = {}) {
    let str = languageMap[key] || key;

    Object.keys(names).forEach((name) => {
      str = str.replace(`{{${name}}}`, names[name]);
    });

    return str;
  }

  return (
    <WishlistProvider>
      <AppContext.Provider value={{ breakpoint, t }}>
        <div className="main-container">
          {children}
        </div>
      </AppContext.Provider>
    </WishlistProvider>
  );
}
